import { StatusPage } from "src/components/StatusPage/StatusPage";

interface AccessDeniedPageProps {
  onSignOut: () => void;
}

/** Shown when a signed-in user's claims don't grant access to the app. */
export function AccessDeniedPage({ onSignOut }: AccessDeniedPageProps) {
  return (
    <StatusPage
      title="Access Denied"
      body="Your account does not have permission to use this application. Please contact your administrator to request access."
      onSignOut={onSignOut}
    />
  );
}
